export default "__VITE_ASSET__Dk6ibL05__"